import {
  Home,
  BookOpen,
  TerminalSquare,
  Briefcase,
  Bookmark,
  FileText,
  MessageCircle,
  Bell,
  Library,
  ListChecks,
  FileBadge2,
  NotebookText,
  Layers,
  Building,
  ClipboardCheck,
  Rocket,
} from "@assets/icons/icons";

export const sidebarItems = [
  {
    name: "Home",
    href: "/",
    icon: <Home className="w-5 h-5" />,
    isPro: false,
    children: [],
  },
  {
    name: "Courses",
    href: "#",
    icon: <BookOpen className="w-5 h-5" />,
    isPro: true,
    children: [
      {
        name: "All Courses",
        href: "/courses",
        icon: <Library className="w-4 h-4" />,
      },
      {
        name: "Cheat Sheets",
        href: "/cheat-sheets",
        icon: <NotebookText className="w-4 h-4" />,
      },
      { name: "MCQs", href: "/mcqs", icon: <ListChecks className="w-4 h-4" /> },
      {
        name: "Mock Test",
        href: "/mock-tests",
        icon: <FileBadge2 className="w-4 h-4" />,
      },
      // {
      //   name: "Projects",
      //   href: "/projects",
      //   icon: <Rocket className="w-4 h-4" />,
      // },
    ],
  },
  // {
  //   name: "Playground",
  //   href: "/coding-playground",
  //   icon: <TerminalSquare className="w-5 h-5" />,
  //   isPro: true,
  //   children: [],
  // },
  {
    name: "Opportunities",
    href: "#",
    icon: <Layers className="w-5 h-5" />,
    children: [
      {
        name: "Jobs",
        href: "/jobs",
        icon: <Briefcase className="w-4 h-4" />,
        badge: "3",
      },
      // {
      //   name: "Saved Jobs",
      //   href: "/saved-jobs",
      //   icon: <Bookmark className="w-4 h-4" />,
      // },
      // {
      //   name: "Applied Jobs",
      //   href: "/applied-jobs",
      //   icon: <Building className="w-4 h-4" />,
      // },
      // {
      //   name: "Companies",
      //   href: "/companies",
      //   icon: <ClipboardCheck className="w-4 h-4" />,
      //   badge: "3",
      // },
    ],
  },
  {
    name: "Resume",
    href: "/resume",
    icon: <FileText className="w-5 h-5" />,
    isPro: false,
    children: [],
  },
  {
    name: "Discussions",
    href: "/discussions",
    icon: <MessageCircle className="w-5 h-5" />,
    isPro: true,
    children: [],
  },
  {
    name: "Updates",
    href: "/updates",
    icon: <Bell className="w-5 h-5" />,
    isPro: true,
    children: [],
  },
];
